export var customTexts = function customTexts(strictLocalize) {
  return {
    actionPaymentCompleted: strictLocalize({
      id: "I8qY2N",
      defaultMessage: [{
        "type": 0,
        "value": "Betaling voltooid"
      }]
    }),
    actionPaymentError: strictLocalize({
      id: "ZAyV+v",
      defaultMessage: [{
        "type": 0,
        "value": "Er is een fout opgetreden bij het verwerken van de kaart. Probeer het opnieuw of gebruik een andere kaart."
      }]
    }),
    actionPostbackError: strictLocalize({
      id: "4nX2E/",
      defaultMessage: [{
        "type": 0,
        "value": "Er is een fout opgetreden bij het verwerken van je actie. Probeer het opnieuw."
      }]
    }),
    clickToRetry: strictLocalize({
      id: "VtFpKp",
      defaultMessage: [{
        "type": 0,
        "value": "Het bericht is niet bezorgd. Vernieuw de browser om het opnieuw te proberen."
      }]
    }),
    clickToRetryForm: strictLocalize({
      id: "u15Uck",
      defaultMessage: [{
        "type": 0,
        "value": "Formulier niet ingediend. Klik ergens op het formulier om het opnieuw te proberen."
      }]
    }),
    connectNotificationText: strictLocalize({
      id: "FNME6m",
      defaultMessage: [{
        "type": 0,
        "value": "Synchroniseer je gesprek en blijf ons berichten sturen via je favoriete app."
      }]
    }),
    connectNotificationSingleText: strictLocalize({
      id: "SQ7ADB",
      defaultMessage: [{
        "type": 0,
        "value": "Ontvang een melding wanneer je een antwoord krijgt."
      }]
    }),
    conversationListHeaderText: strictLocalize({
      id: "8mVcn4",
      defaultMessage: [{
        "type": 0,
        "value": "Mijn gesprekken"
      }]
    }),
    conversationListPreviewAnonymousText: strictLocalize({
      id: "d5Sp/y",
      defaultMessage: [{
        "type": 0,
        "value": "Iemand"
      }]
    }),
    conversationListPreviewCarouselText: strictLocalize({
      id: "BNBuTY",
      defaultMessage: [{
        "type": 1,
        "value": "userPersonName"
      }, {
        "type": 0,
        "value": " heeft een bericht verzonden"
      }]
    }, {
      userPersonName: "{user}"
    }),
    conversationListPreviewFileText: strictLocalize({
      id: "Um9Kpq",
      defaultMessage: [{
        "type": 1,
        "value": "userPersonName"
      }, {
        "type": 0,
        "value": " heeft een bestand gestuurd"
      }]
    }, {
      userPersonName: "{user}"
    }),
    conversationListPreviewFormText: strictLocalize({
      id: "1fsFts",
      defaultMessage: [{
        "type": 1,
        "value": "userPersonName"
      }, {
        "type": 0,
        "value": " heeft een formulier verzonden"
      }]
    }, {
      userPersonName: "{user}"
    }),
    conversationListPreviewFormResponseText: strictLocalize({
      id: "OMXLSv",
      defaultMessage: [{
        "type": 1,
        "value": "userPersonName"
      }, {
        "type": 0,
        "value": " heeft een formulier ingevuld"
      }]
    }, {
      userPersonName: "{user}"
    }),
    conversationListPreviewImageText: strictLocalize({
      id: "8nkquk",
      defaultMessage: [{
        "type": 1,
        "value": "userPersonName"
      }, {
        "type": 0,
        "value": " heeft een afbeelding verzonden"
      }]
    }, {
      userPersonName: "{user}"
    }),
    conversationListPreviewLocationRequestText: strictLocalize({
      id: "p/7Vs+",
      defaultMessage: [{
        "type": 1,
        "value": "userPersonName"
      }, {
        "type": 0,
        "value": " heeft een locatieverzoek gestuurd"
      }]
    }, {
      userPersonName: "{user}"
    }),
    conversationListPreviewUserText: strictLocalize({
      id: "5p2Qih",
      defaultMessage: [{
        "type": 0,
        "value": "Jij"
      }]
    }),
    conversationListRelativeTimeJustNow: strictLocalize({
      id: "72Tqww",
      defaultMessage: [{
        "type": 0,
        "value": "Zojuist"
      }]
    }),
    conversationListRelativeTimeMinute: strictLocalize({
      id: "IjmHdR",
      defaultMessage: [{
        "type": 0,
        "value": "1 minuut geleden"
      }]
    }),
    conversationListRelativeTimeMinutes: strictLocalize({
      id: "hBcPit",
      defaultMessage: [{
        "type": 1,
        "value": "valueTime"
      }, {
        "type": 0,
        "value": " minuten geleden"
      }]
    }, {
      valueTime: "{value}"
    }),
    conversationListRelativeTimeHour: strictLocalize({
      id: "GZ73D9",
      defaultMessage: [{
        "type": 0,
        "value": "1 uur geleden"
      }]
    }),
    conversationListRelativeTimeHours: strictLocalize({
      id: "D1AceC",
      defaultMessage: [{
        "type": 1,
        "value": "valueTime"
      }, {
        "type": 0,
        "value": " uur geleden"
      }]
    }, {
      valueTime: "{value}"
    }),
    conversationListRelativeTimeYesterday: strictLocalize({
      id: "9Cwjfp",
      defaultMessage: [{
        "type": 0,
        "value": "Gisteren"
      }]
    }),
    couldNotConnect: strictLocalize({
      id: "UjUBuG",
      defaultMessage: [{
        "type": 0,
        "value": "Offline. Je ontvangt geen berichten."
      }]
    }),
    couldNotConnectRetry: strictLocalize({
      id: "kXGiZU",
      defaultMessage: [{
        "type": 0,
        "value": "Opnieuw verbinden ..."
      }]
    }),
    couldNotConnectRetrySuccess: strictLocalize({
      id: "WxKYO6",
      defaultMessage: [{
        "type": 0,
        "value": "Je bent weer online."
      }]
    }),
    couldNotLoadConversations: strictLocalize({
      id: "NT287R",
      defaultMessage: [{
        "type": 0,
        "value": "Kan gesprekken niet laden."
      }]
    }),
    emailChangeAddress: strictLocalize({
      id: "lMdZaG",
      defaultMessage: [{
        "type": 0,
        "value": "Mijn e-mailadres wijzigen"
      }]
    }),
    emailDescription: strictLocalize({
      id: "FtDtu+",
      defaultMessage: [{
        "type": 0,
        "value": "Voer je e-mailadres in om een e-mailbericht te ontvangen als je een antwoord ontvangt."
      }]
    }),
    emailFieldLabel: strictLocalize({
      id: "3bcv4v",
      defaultMessage: [{
        "type": 0,
        "value": "E-mail"
      }]
    }),
    emailFieldPlaceholder: strictLocalize({
      id: "2L9ili",
      defaultMessage: [{
        "type": 0,
        "value": "Je e-mailadres"
      }]
    }),
    emailFormButton: strictLocalize({
      id: "OCxMgt",
      defaultMessage: [{
        "type": 0,
        "value": "Indienen"
      }]
    }),
    emailLinkingErrorMessage: strictLocalize({
      id: "pJuL3D",
      defaultMessage: [{
        "type": 0,
        "value": "Voer een geldig e-mailadres in."
      }]
    }),
    fetchHistory: strictLocalize({
      id: "n288kk",
      defaultMessage: [{
        "type": 0,
        "value": "Meer laden"
      }]
    }),
    fetchingHistory: strictLocalize({
      id: "p0LVGs",
      defaultMessage: [{
        "type": 0,
        "value": "Bezig met ophalen van geschiedenis ..."
      }]
    }),
    fileTooLargeError: strictLocalize({
      id: "Yl3C6g",
      defaultMessage: [{
        "type": 0,
        "value": "Maximale bestandsgrootte ("
      }, {
        "type": 1,
        "value": "sizeNumber"
      }, {
        "type": 0,
        "value": ") overschreden"
      }]
    }, {
      sizeNumber: "{size}"
    }),
    fileTypeError: strictLocalize({
      id: "GpVgdA",
      defaultMessage: [{
        "type": 0,
        "value": "Niet-ondersteund bestandstype."
      }]
    }),
    formErrorEntryRequired: strictLocalize({
      id: "U6eN9Z",
      defaultMessage: [{
        "type": 0,
        "value": "Dit veld is verplicht"
      }]
    }),
    formErrorInvalidEmail: strictLocalize({
      id: "CfLksk",
      defaultMessage: [{
        "type": 0,
        "value": "E-mailadres is ongeldig"
      }]
    }),
    formErrorNoLongerThan: strictLocalize({
      id: "gZ/mqf",
      defaultMessage: [{
        "type": 0,
        "value": "Mag niet meer dan ("
      }, {
        "type": 1,
        "value": "charactersNumber"
      }, {
        "type": 0,
        "value": ") tekens bevatten"
      }]
    }, {
      charactersNumber: "{characters}"
    }),
    formErrorNoShorterThan: strictLocalize({
      id: "6UhNRq",
      defaultMessage: [{
        "type": 0,
        "value": "Moet ten minste ("
      }, {
        "type": 1,
        "value": "charactersNumber"
      }, {
        "type": 0,
        "value": ") tekens bevatten"
      }]
    }, {
      charactersNumber: "{characters}"
    }),
    formErrorUnknown: strictLocalize({
      id: "uHmA0t",
      defaultMessage: [{
        "type": 0,
        "value": "Dit ziet er niet goed uit"
      }]
    }),
    formFieldSelectPlaceholderFallback: strictLocalize({
      id: "IqApqR",
      defaultMessage: [{
        "type": 0,
        "value": "Kies er een ..."
      }]
    }),
    frontendEmailChannelDescription: strictLocalize({
      id: "UrftLW",
      defaultMessage: [{
        "type": 0,
        "value": "Als je contact met ons wilt opnemen via e-mail, stuur dan een bericht naar ons e-mailadres en we zullen je zo snel mogelijk antwoorden:"
      }]
    }),
    headerText: strictLocalize({
      id: "LzUo5v",
      defaultMessage: [{
        "type": 0,
        "value": "Hoe kunnen we helpen?"
      }]
    }),
    imageClickToReload: strictLocalize({
      id: "MYu9Dn",
      defaultMessage: [{
        "type": 0,
        "value": "Klik om de afbeelding opnieuw te laden."
      }]
    }),
    imageClickToView: strictLocalize({
      id: "iDcbK1",
      defaultMessage: [{
        "type": 0,
        "value": "Klik om de afbeelding van "
      }, {
        "type": 1,
        "value": "sizeNumber"
      }, {
        "type": 0,
        "value": " te bekijken."
      }]
    }, {
      sizeNumber: "{size}"
    }),
    imagePreviewNotAvailable: strictLocalize({
      id: "7xJ0Oe",
      defaultMessage: [{
        "type": 0,
        "value": "Voorbeeld niet beschikbaar."
      }]
    }),
    inputPlaceholder: strictLocalize({
      id: "Qz0IJv",
      defaultMessage: [{
        "type": 0,
        "value": "Typ een bericht ..."
      }]
    }),
    inputPlaceholderBlocked: strictLocalize({
      id: "lKCy+g",
      defaultMessage: [{
        "type": 0,
        "value": "Vul het bovenstaande formulier in ..."
      }]
    }),
    introAppText: strictLocalize({
      id: "WwisEh",
      defaultMessage: [{
        "type": 0,
        "value": "Stuur ons hieronder een bericht of gebruik je favoriete app."
      }]
    }),
    lineChannelDescription: strictLocalize({
      id: "82iecS",
      defaultMessage: [{
        "type": 0,
        "value": "Als je met ons wilt chatten via LINE, scan dan deze QR-code met de LINE-app en stuur ons een bericht."
      }]
    }),
    linkError: strictLocalize({
      id: "hlZfbl",
      defaultMessage: [{
        "type": 0,
        "value": "Er is een fout opgetreden bij het genereren van een link voor dit kanaal. Probeer het opnieuw."
      }]
    }),
    linkChannelPageHeader: strictLocalize({
      id: "jSbwQA",
      defaultMessage: [{
        "type": 0,
        "value": "Je gesprek synchroniseren"
      }]
    }),
    locationNotSupported: strictLocalize({
      id: "0cajDz",
      defaultMessage: [{
        "type": 0,
        "value": "Je browser ondersteunt geen locatieservices of deze zijn uitgeschakeld. Typ in plaats daarvan je locatie."
      }]
    }),
    locationSecurityRestriction: strictLocalize({
      id: "Q20rDu",
      defaultMessage: [{
        "type": 0,
        "value": "Deze website heeft geen toegang tot je locatie. Typ in plaats daarvan je locatie."
      }]
    }),
    locationSendingFailed: strictLocalize({
      id: "XWNAd3",
      defaultMessage: [{
        "type": 0,
        "value": "Kan locatie niet verzenden"
      }]
    }),
    locationServicesDenied: strictLocalize({
      id: "EavZzB",
      defaultMessage: [{
        "type": 0,
        "value": "Deze website heeft geen toegang tot je locatie. Verleen toegang in je instellingen of typ in plaats daarvan je locatie."
      }]
    }),
    messageIndicatorTitlePlural: strictLocalize({
      id: "0+VvFB",
      defaultMessage: [{
        "type": 1,
        "value": "countNumber"
      }, {
        "type": 0,
        "value": " nieuwe berichten"
      }]
    }, {
      countNumber: "{count}"
    }),
    messageIndicatorTitleSingular: strictLocalize({
      id: "CSCZoW",
      defaultMessage: [{
        "type": 1,
        "value": "countNumber"
      }, {
        "type": 0,
        "value": " nieuw bericht"
      }]
    }, {
      countNumber: "{count}"
    }),
    messageRelativeTimeDay: strictLocalize({
      id: "xo/4Yu",
      defaultMessage: [{
        "type": 1,
        "value": "valueTime"
      }, {
        "type": 0,
        "value": " d geleden"
      }]
    }, {
      valueTime: "{value}"
    }),
    messageRelativeTimeHour: strictLocalize({
      id: "bdg3Pr",
      defaultMessage: [{
        "type": 1,
        "value": "valueTime"
      }, {
        "type": 0,
        "value": " u geleden"
      }]
    }, {
      valueTime: "{value}"
    }),
    messageRelativeTimeJustNow: strictLocalize({
      id: "72Tqww",
      defaultMessage: [{
        "type": 0,
        "value": "Zojuist"
      }]
    }),
    messageRelativeTimeMinute: strictLocalize({
      id: "SyJ9Zm",
      defaultMessage: [{
        "type": 1,
        "value": "valueTime"
      }, {
        "type": 0,
        "value": " m geleden"
      }]
    }, {
      valueTime: "{value}"
    }),
    messageDelivered: strictLocalize({
      id: "I9y4Q1",
      defaultMessage: [{
        "type": 0,
        "value": "Afgeleverd"
      }]
    }),
    messageSeen: strictLocalize({
      id: "2552ol",
      defaultMessage: [{
        "type": 0,
        "value": "Gezien"
      }]
    }),
    messageSending: strictLocalize({
      id: "CzlJFq",
      defaultMessage: [{
        "type": 0,
        "value": "Bezig met verzenden ..."
      }]
    }),
    messengerChannelDescription: strictLocalize({
      id: "EBuhyl",
      defaultMessage: [{
        "type": 0,
        "value": "Koppel je Facebook Messenger-account om een melding te ontvangen wanneer je een antwoord krijgt en om het gesprek voort te zetten op Facebook Messenger."
      }]
    }),
    newConversationButtonText: strictLocalize({
      id: "79XsJP",
      defaultMessage: [{
        "type": 0,
        "value": "Nieuw gesprek"
      }]
    }),
    notificationSettingsChannelsDescription: strictLocalize({
      id: "nmmSL2",
      defaultMessage: [{
        "type": 0,
        "value": "Synchroniseer dit gesprek door verbinding te maken met je favoriete berichtenapp. Zo kun je het gesprek op jouw manier voort te zetten."
      }]
    }),
    notificationSettingsChannelsTitle: strictLocalize({
      id: "WuUmeV",
      defaultMessage: [{
        "type": 0,
        "value": "Andere kanalen"
      }]
    }),
    notificationSettingsConnected: strictLocalize({
      id: "h3RKIm",
      defaultMessage: [{
        "type": 0,
        "value": "Gekoppeld"
      }]
    }),
    notificationSettingsConnectedAs: strictLocalize({
      id: "uepWZ4",
      defaultMessage: [{
        "type": 0,
        "value": "Gekoppeld als "
      }, {
        "type": 1,
        "value": "userPersonName"
      }]
    }, {
      userPersonName: "{username}"
    }),
    prechatCaptureGreetingText: strictLocalize({
      id: "JUJtTk",
      defaultMessage: [{
        "type": 0,
        "value": "Hallo. We willen eerst wat meer over je weten:"
      }]
    }),
    prechatCaptureNameLabel: strictLocalize({
      id: "uLbNUt",
      defaultMessage: [{
        "type": 0,
        "value": "Jouw naam"
      }]
    }),
    prechatCaptureNamePlaceholder: strictLocalize({
      id: "RwY05X",
      defaultMessage: [{
        "type": 0,
        "value": "Typ je naam ..."
      }]
    }),
    prechatCaptureEmailLabel: strictLocalize({
      id: "kJy+AB",
      defaultMessage: [{
        "type": 0,
        "value": "E-mail"
      }]
    }),
    prechatCaptureEmailPlaceholder: strictLocalize({
      id: "bHoo9p",
      defaultMessage: [{
        "type": 0,
        "value": "name@company.com"
      }]
    }),
    prechatCaptureConfirmationText: strictLocalize({
      id: "MxlmAH",
      defaultMessage: [{
        "type": 0,
        "value": "Bedankt! Waar kunnen we je mee helpen?"
      }]
    }),
    prechatCaptureMailgunLinkingConfirmation: strictLocalize({
      id: "qhC82s",
      defaultMessage: [{
        "type": 0,
        "value": "Je krijgt zowel hier als per e-mail op "
      }, {
        "type": 1,
        "value": "emailEmailAddress"
      }, {
        "type": 0,
        "value": " een bericht zodra we reageren."
      }]
    }, {
      emailEmailAddress: "{email}"
    }),
    sendButtonText: strictLocalize({
      id: "xLWTdR",
      defaultMessage: [{
        "type": 0,
        "value": "Verzenden"
      }]
    }),
    settingsHeaderText: strictLocalize({
      id: "0QV6z2",
      defaultMessage: [{
        "type": 0,
        "value": "Instellingen"
      }]
    }),
    shareLocation: strictLocalize({
      id: "rvirM2",
      defaultMessage: [{
        "type": 0,
        "value": "Locatie"
      }]
    }),
    smsBadRequestError: strictLocalize({
      id: "d5wiZz",
      defaultMessage: [{
        "type": 0,
        "value": "We kunnen niet communiceren met dit nummer. Probeer het opnieuw of gebruik een ander nummer."
      }]
    }),
    smsCancel: strictLocalize({
      id: "gHLemI",
      defaultMessage: [{
        "type": 0,
        "value": "Annuleren"
      }]
    }),
    smsChangeNumber: strictLocalize({
      id: "T9LQOH",
      defaultMessage: [{
        "type": 0,
        "value": "Mijn nummer wijzigen"
      }]
    }),
    smsChannelDescription: strictLocalize({
      id: "E9/0ru",
      defaultMessage: [{
        "type": 0,
        "value": "Koppel je mobiele nummer om een melding te ontvangen wanneer je een antwoord krijgt en om het gesprek voort te zetten via sms."
      }]
    }),
    smsChannelPendingDescription: strictLocalize({
      id: "spQ3hG",
      defaultMessage: [{
        "type": 0,
        "value": "Controleer je berichten op "
      }, {
        "type": 1,
        "value": "phoneNumber"
      }, {
        "type": 0,
        "value": " om je telefoonnummer te bevestigen."
      }]
    }, {
      phoneNumber: "{number}"
    }),
    smsContinue: strictLocalize({
      id: "xLWTdR",
      defaultMessage: [{
        "type": 0,
        "value": "Verzenden"
      }]
    }),
    smsInvalidNumberError: strictLocalize({
      id: "QaDAmJ",
      defaultMessage: [{
        "type": 0,
        "value": "Voer een geldig telefoonnummer in."
      }]
    }),
    smsLinkCancelled: strictLocalize({
      id: "q4dN8U",
      defaultMessage: [{
        "type": 0,
        "value": "Koppeling aan "
      }, {
        "type": 1,
        "value": "appUserNumber"
      }, {
        "type": 0,
        "value": " is geannuleerd."
      }]
    }, {
      appUserNumber: "{appUserNumber}"
    }),
    smsLinkPending: strictLocalize({
      id: "I1RY7U",
      defaultMessage: [{
        "type": 0,
        "value": "In afwachting"
      }]
    }),
    smsPingChannelError: strictLocalize({
      id: "UBAoB1",
      defaultMessage: [{
        "type": 0,
        "value": "Er is een fout opgetreden bij het verzenden van een bericht naar je nummer."
      }]
    }),
    smsSendText: strictLocalize({
      id: "x7rAeU",
      defaultMessage: [{
        "type": 0,
        "value": "Stuur me een sms"
      }]
    }),
    smsStartTexting: strictLocalize({
      id: "TGJUj4",
      defaultMessage: [{
        "type": 0,
        "value": "Begin met sms’en"
      }]
    }),
    smsTooManyRequestsError: strictLocalize({
      id: "jVSLkV",
      defaultMessage: [{
        "type": 0,
        "value": "Er is onlangs geprobeerd om dit telefoonnummer te koppelen. Probeer het over "
      }, {
        "type": 1,
        "value": "minutesTime"
      }, {
        "type": 0,
        "value": " minuten opnieuw."
      }]
    }, {
      minutesTime: "{minutes}"
    }),
    smsTooManyRequestsOneMinuteError: strictLocalize({
      id: "0XliGQ",
      defaultMessage: [{
        "type": 0,
        "value": "Er is onlangs geprobeerd om dit telefoonnummer te koppelen. Probeer het over 1 minuut opnieuw."
      }]
    }),
    smsUnhandledError: strictLocalize({
      id: "W1a+Iy",
      defaultMessage: [{
        "type": 0,
        "value": "Er is iets misgegaan. Probeer het opnieuw."
      }]
    }),
    syncConversation: strictLocalize({
      id: "B2qj3w",
      defaultMessage: [{
        "type": 0,
        "value": "Gesprek synchroniseren"
      }]
    }),
    tapToRetry: strictLocalize({
      id: "P7ZSoc",
      defaultMessage: [{
        "type": 0,
        "value": "Het bericht is niet bezorgd. Tik om het opnieuw te proberen."
      }]
    }),
    tapToRetryForm: strictLocalize({
      id: "QqMyCB",
      defaultMessage: [{
        "type": 0,
        "value": "Formulier niet ingediend. Tik ergens op het formulier om het opnieuw te proberen."
      }]
    }),
    telegramChannelDescription: strictLocalize({
      id: "Rtuws+",
      defaultMessage: [{
        "type": 0,
        "value": "Koppel je Telegram-account om een melding te ontvangen wanneer je een antwoord krijgt en om het gesprek voort te zetten op Telegram"
      }]
    }),
    unsupportedMessageType: strictLocalize({
      id: "E9qCDM",
      defaultMessage: [{
        "type": 0,
        "value": "Niet-ondersteund berichttype."
      }]
    }),
    unsupportedActionType: strictLocalize({
      id: "mMB611",
      defaultMessage: [{
        "type": 0,
        "value": "Niet-ondersteund actietype."
      }]
    }),
    uploadDocument: strictLocalize({
      id: "hdlOID",
      defaultMessage: [{
        "type": 0,
        "value": "Bestand"
      }]
    }),
    uploadInvalidError: strictLocalize({
      id: "gn05y6",
      defaultMessage: [{
        "type": 0,
        "value": "Ongeldig bestand"
      }]
    }),
    uploadPhoto: strictLocalize({
      id: "OAzZGu",
      defaultMessage: [{
        "type": 0,
        "value": "Afbeelding"
      }]
    }),
    uploadVirusError: strictLocalize({
      id: "x5EOZK",
      defaultMessage: [{
        "type": 0,
        "value": "Er werd een virus gedetecteerd in je bestand en het is geweigerd"
      }]
    }),
    viberChannelDescription: strictLocalize({
      id: "Z3K0oO",
      defaultMessage: [{
        "type": 0,
        "value": "Koppel je Viber-account om een melding te ontvangen wanneer je een antwoord krijgt en om het gesprek voort te zetten op Viber. Scan de QR-code met de Viber-app om te beginnen."
      }]
    }),
    viberChannelDescriptionMobile: strictLocalize({
      id: "xuYgMg",
      defaultMessage: [{
        "type": 0,
        "value": "Koppel je Viber-account om een melding te ontvangen wanneer je een antwoord krijgt en om het gesprek voort te zetten op Viber. Om te beginnen installeer je de Viber-app en tik je op Verbinden."
      }]
    }),
    viberQRCodeError: strictLocalize({
      id: "AYSCMJ",
      defaultMessage: [{
        "type": 0,
        "value": "Er is een fout opgetreden bij het ophalen van je Viber QR-code. Probeer het opnieuw."
      }]
    }),
    wechatChannelDescription: strictLocalize({
      id: "qIPntD",
      defaultMessage: [{
        "type": 0,
        "value": "Koppel je WeChat-account om een melding te ontvangen wanneer je een antwoord krijgt en het gesprek voort te zetten op WeChat. Om te beginnen scan je deze QR-code met de WeChat-app."
      }]
    }),
    wechatChannelDescriptionMobile: strictLocalize({
      id: "4p4TBs",
      defaultMessage: [{
        "type": 0,
        "value": "Koppel je WeChat-account om een melding te ontvangen wanneer je een antwoord krijgt en het gesprek voort te zetten op WeChat. Om te beginnen sla je deze afbeelding van de QR-code op en upload je deze vervolgens in de QR-codescanner."
      }]
    }),
    wechatQRCodeError: strictLocalize({
      id: "TdTat4",
      defaultMessage: [{
        "type": 0,
        "value": "Er is een fout opgetreden bij het ophalen van je WeChat QR-code. Probeer het opnieuw."
      }]
    }),
    whatsappChannelDescriptionDesktop: strictLocalize({
      id: "tlAllf",
      defaultMessage: [{
        "type": 0,
        "value": "Synchroniseer je account met WhatsApp door de QR-code te scannen of op de onderstaande link te klikken. Stuur vervolgens het vooraf ingevulde bericht om het synchronisatieverzoek te valideren. (Je code: "
      }, {
        "type": 1,
        "value": "codeNumber"
      }, {
        "type": 0,
        "value": ")"
      }]
    }, {
      codeNumber: "{code}"
    }),
    whatsappChannelDescriptionMobile: strictLocalize({
      id: "/YEwfr",
      defaultMessage: [{
        "type": 0,
        "value": "Synchroniseer je account met WhatsApp door op de onderstaande link te klikken. Stuur vervolgens het vooraf ingevulde bericht om het synchronisatieverzoek te valideren. (Je code: "
      }, {
        "type": 1,
        "value": "codeNumber"
      }, {
        "type": 0,
        "value": ")"
      }]
    }, {
      codeNumber: "{code}"
    }),
    whatsappLinkingError: strictLocalize({
      id: "49auTS",
      defaultMessage: [{
        "type": 0,
        "value": "Er is een fout opgetreden bij het ophalen van je WhatsApp-koppelgegevens. Probeer het opnieuw."
      }]
    })
  };
};